module.exports = __webpack_public_path__ + "images/687986e39b80f7b6b15ec438288d52d6.svg";